import React from 'react';
import {connect} from "react-redux";
import RaisedButton from 'material-ui/RaisedButton';
import TitleMedium from './../../shared/utils/TitleMedium';
import moment from './../../shared/utils/moment_fr';
import Alert from "../../shared/utils/Alert";
import SalarieService from "../services/SalarieService";
import {getAllEntretiens} from "../../../actions/salarie/actions_salarie_1";
import CustomDatePicker from "../../shared/utils/CustomDatePicker";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";

class EntretiensSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isPropositionBlockVisible: false,
            rdv: {
                day: new Date(),
                hour: '09',
                minute: '30'
            },
        };
        this.salarieService = new SalarieService();
        this.getStatusOfEntretien = this.getStatusOfEntretien.bind(this);
        this.onAcceptRdv = this.onAcceptRdv.bind(this);
        this.onSuggestRdvClick = this.onSuggestRdvClick.bind(this);
    }

    getStatusOfEntretien(type) {
        switch (type) {
            case '0':
                return 'Non';
            case '1':
                return 'Oui';
            case '2':
                return 'En Attente';
            default:
                return 'Non';
        }
    }

    onAcceptRdv(e) {
        const x = window.confirm('Êtes-vous sûr de vouloir Accepter votre entretien prévu pour le ' +
            moment(e.date_heure).format('DD/MM/YYYY HH:mm') + '\nCette action n\'est pas réversible.');
        if (x) {
            this.salarieService.acceptEntretien({is_accepted: "1", id_entretien: e.id})
                .then(() => this.props.dispatch(getAllEntretiens()));
        }
    }

    onDenyRdv(e) {
        const x = window.confirm('Êtes-vous sûr de vouloir refuser votre entretien prévu pour le ' +
            moment(e.date_heure).format('DD/MM/YYYY HH:mm') + '\nCette action n\'est pas réversible.');
        if (x) {
            this.salarieService.acceptEntretien({is_accepted: "0", id_entretien: e.id})
                .then(() => this.props.dispatch(getAllEntretiens()));
        }
    }

    onSuggestRdvClick() {
        const x = window.confirm('Êtes-vous sûr de vouloir demander un entretien  ? ' +
            '\nCette action n\'est pas réversible.');
        if (x) {
            this.salarieService.demandeEntretien({...this.state.rdv, id_salarie: this.props.id_salarie})
                .then(() => {
                    this.props.dispatch(getAllEntretiens());
                    this.setState({isPropositionBlockVisible: false});
                    window.alert('Entretien demandé avec succès');
                })
        }

    }

    setDate(value, position) {
        switch (position) {
            case 'day':
                this.setState({rdv: {...this.state.rdv, day: value}});
                break;
            case 'hours' :
                value = parseInt(value, 10);
                value = value < 10 ? '0' + value : '' + value;
                this.setState({rdv: {...this.state.rdv, hour: value}});
                break;
            case 'minutes' :
                value = parseInt(value, 10);
                value = value < 10 ? '0' + value : '' + value;
                this.setState({rdv: {...this.state.rdv, minute: value}});
                break;
            default:
                break;
        }

    }


    render() {
        return (
            <div style={{padding: 20}} className={'row'}>
                <div className={'col'}>
                    <TitleMedium title={'Vos entretiens prévus'}/>
                    {this.props.opened && this.props.opened.length > 0 ?
                        <table className={'table'}>
                            <thead>
                            <tr>
                                <th style={{width: 200}}>Date de passage prévue</th>
                                <th>Type de l'entretien</th>
                                <th>RDV validé par entretpise ?</th>
                                <th>RDV validé par le salarié ?</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.opened.map(e =>
                                <tr key={e.id}>
                                    <td style={{width: 200}}>{moment(e.date_heure).format('DD/MM/YYYY HH:mm')}</td>
                                    <td>{e.type}</td>
                                    <td>{this.getStatusOfEntretien(e.is_accepted_by_entreprise)}</td>
                                    <td>
                                        {
                                            e.is_accepted_by_salarie === '2' ?
                                                <div>
                                                    <RaisedButton label={'Accepter le rendez vous'}
                                                                  fullWidth={true}
                                                                  secondary={true}
                                                                  style={{marginBottom: 5}}
                                                                  onClick={() => this.onAcceptRdv(e)}/><br/>
                                                    <RaisedButton label={'Refuser le rendez vous'}
                                                                  fullWidth={true}
                                                                  backgroundColor='#FFFF00 '
                                                                  labelColor='#000000'
                                                                  onClick={() => this.onDenyRdv(e)}/><br/>
                                                </div>
                                                : this.getStatusOfEntretien(e.is_accepted_by_salarie)
                                        }
                                    </td>
                                </tr>
                            )}

                            </tbody>
                        </table>
                        : <Alert text="Aucun entretien n'est prévu pour vous actuellement."/>
                    }
                    <RaisedButton label={'Proposer un entretien à votre hiérarchie'}
                                  primary={true}
                                  onClick={() => this.setState({isPropositionBlockVisible: true})}/><br/><br/>
                    {this.state.isPropositionBlockVisible &&
                    <div>
                        <Alert
                            text="Vous pouvez proposer un entretien avec votre employeur en remplissant le formulaire ci-dessous : ">
                            <ValidatorForm
                                style={{backgroundColor: 'white', padding: 10, marginTop: 10}}
                                onSubmit={(x) => this.onSuggestRdvClick()}
                            >
                                <CustomDatePicker
                                    floatingLabelText={"Date de l'entretien"}
                                    stringValue={moment(this.state.rdv.day).format('YYYY-MM-DD')}
                                    onChange={(x, y) => this.setDate(y, 'day')}
                                />
                                <div className={'row'}>
                                    <div className={'col'}>
                                        <TextValidator
                                            value={this.state.rdv.hour}
                                            onChange={(x, y) => this.setDate(y, 'hours')}
                                            fullWidth={true}
                                            name='hours'
                                            type="number"
                                            validators={['required', 'isNumber', 'minNumber:0', 'maxNumber:23']}
                                            errorMessages={[
                                                'Ce champs est obligatoire',
                                                'Ce champs est doit représenter une heure (hh).',
                                                'Valeur minimale : 0',
                                                'Valeur maximale : 23',
                                            ]}
                                            floatingLabelText="Heure"
                                        />
                                    </div>
                                    <div className={'col'}>
                                        <TextValidator
                                            value={this.state.rdv.minute}
                                            onChange={(x, y) => this.setDate(y, 'minutes')}
                                            fullWidth={true}
                                            type="number"
                                            name='minutes'
                                            validators={['required', 'isNumber', 'minNumber:0', 'maxNumber:59']}
                                            errorMessages={[
                                                'Ce champs est obligatoire',
                                                'Ce champs est doit représenter des minutes (mm).',
                                                'Valeur minimale : 0',
                                                'Valeur maximale : 59',
                                            ]}
                                            floatingLabelText="Minutes"
                                        />
                                    </div>

                                </div>
                                <br/><br/>
                                <RaisedButton type='submit' label="Proposer" primary={true}/>
                                <RaisedButton
                                    type='button'
                                    label="Annuler"
                                    style={{marginLeft: 25}}
                                    primary={false}
                                    onClick={() => this.setState({isPropositionBlockVisible: false})}/>
                            </ValidatorForm>
                        </Alert>
                    </div>
                    }
                    <TitleMedium title={'Vos entretiens signés'}/>
                    {this.props.signed && this.props.signed.length > 0 ?
                        <table className={'table'}>
                            <thead>
                            <tr>
                                <th style={{width: 200}}>Date de signature</th>
                                <th>Type de l'entretien</th>
                                <th>PDF</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.signed.map(e =>
                                <tr key={e.id}>
                                    <td style={{width: 200}}>{moment(e.date_heure).format('DD/MM/YYYY HH:mm')}</td>
                                    <td>{e.type}</td>
                                    <td><RaisedButton label={'PDF'} primary={true}
                                                      onClick={() => this.salarieService.downloadSignedentretien(e.id)}/>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        : <Alert text="Aucun entretien signé n'est disponible pour vous actuellement."/>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        signed: store.salarie.entretiens.signed,
        opened: store.salarie.entretiens.opened,
        id_salarie: store.salarie.infos.id
    }
}

export default connect(mapStateToProps)(EntretiensSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/EntretiensSalarie.js